import React, { useState, useEffect } from "react";
import TableCompo from "../MainScreens/Table/TableCompo";
import {
  Box,
  Typography,
  CardContent,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  MenuItem,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  getTicketsRequest,
  saveTicketRequest,
  updateTicketStatusRequest,
} from "../../redux/Tickets/ticketSlice";
import TicketItemDrawer from "./TicketItemDrawer";
import { toast } from "react-toastify";
import { canShowPermission } from "../MainScreens/Permissions/permissionObject";
import { CiEdit } from "react-icons/ci";
import { getAppConfig } from "../../redux/Configuration/configurationSlice";
import FeatureUnavailable from "../Comman/FeatureUnavailable";
import useCsvConverter from "../../hooks/convertToCSV";
import { apiRequest } from "../../redux/Reports/reportsSlice";
import InfoButton from "../Comman/InfoButton";

const Tickets = () => {
  const dispatch = useDispatch();
  const { convertToCsv } = useCsvConverter();
  const TicketsState = useSelector((state) => state.tickets || {});
  const { ticketData = [], total = 0 } = TicketsState;
  const [open, setOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [file, setFile] = useState(null);
  const [pagination, setPagination] = useState({ page: 0, limit: 10 });
  const [statusFilter, setStatusFilter] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [statusDialogOpen, setStatusDialogOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedTicketId, setSelectedTicketId] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [search, setSearch] = useState("");
  const [dueDateFilter, setDueDateFilter] = useState("");
  const [permissions, setPermissions] = useState({});
  const configData = useSelector((state) => state.appConfig.configData);
  // useEffect(() => {
  //   dispatch(getAppConfig());
  // }, []);
  useEffect(() => {
    const storedPermissions = localStorage.getItem("userPermissions");

    if (storedPermissions) {
      try {
        setPermissions(JSON.parse(storedPermissions));
      } catch (error) {
        console.error("Error parsing stored permissions", error);
      }
    }
  }, []);

  const [ticket, setTicket] = useState({
    title: "",
    type: "",
    description: "",
    severity: "",
  });

  const handleTableChange = (action, tableState) => {
    switch (action) {
      case "changePage":
        setPagination((prev) => ({ ...prev, page: tableState.page }));
        break;

      case "changeRowsPerPage":
        setPagination({ page: 0, limit: tableState.rowsPerPage });
        break;

      case "search":
        setSearch(tableState.searchText || "");

        setPagination((prev) => ({
          ...prev,
          page: 0,
        }));
        break;

      default:
        break;
    }
  };

  const canEdit = canShowPermission(permissions, "jeweller", "edit");
  const canEditTicket = canShowPermission(permissions, "ticket", "edit");
  const canCreateTicket = canShowPermission(permissions, "ticket", "create");

  useEffect(() => {
    let formattedDueDate = "";

    if (dueDateFilter) {
      const [year, month, day] = dueDateFilter.split("-");

      formattedDueDate = `${day}-${month}-${year}`;
    }
    dispatch(
      getTicketsRequest({
        page: pagination.page + 1,
        limit: pagination.limit,
        status: statusFilter,
        search: search,
        dueDate: formattedDueDate,
      }),
    );
  }, [dispatch, pagination, statusFilter, dueDateFilter, search]);

  const columns = [
    {
      field: "createdAt",
      headerName: "Created At",
      render: (val, row) => {
        const date = new Date(row.createdAt);

        return (
          <span onClick={() => openItem(row)} style={{ cursor: "pointer" }}>
            {date.toLocaleString("en-IN")}
          </span>
        );
      },
    },
    {
      field: "jeweller",
      headerName: "Jeweller Name",
      minWidth: 100,
      render: (_, row) => (
        <span onClick={() => openItem(row)} style={{ cursor: "pointer" }}>
          {row?.jeweller?.jewellerName || "-"}
        </span>
      ),
    },
    {
      field: "title",
      headerName: "Title",
      render: (val, row) => (
        <span onClick={() => openItem(row)} style={{ cursor: "pointer" }}>
          {row?.title || "-"}
        </span>
      ),
    },
    {
      field: "type",
      headerName: "Type",
      render: (val, row) => (
        <span onClick={() => openItem(row)} style={{ cursor: "pointer" }}>
          {row?.type || "-"}
        </span>
      ),
    },
    {
      field: "severity",
      headerName: "Severity",
      render: (val, row) => (
        <span onClick={() => openItem(row)} style={{ cursor: "pointer" }}>
          {row?.severity || "-"}
        </span>
      ),
    },
    {
      field: "description",
      headerName: "Description",
      render: (val, row) => (
        <span onClick={() => openItem(row)} style={{ cursor: "pointer" }}>
          {row?.description || "-"}
        </span>
      ),
    },
    {
      field: "assignedBy",
      headerName: "Assigned By",
      render: (_, row) => (
        <span onClick={() => openItem(row)} style={{ cursor: "pointer" }}>
          {row?.assignedBy?.name || "-"}
        </span>
      ),
    },
    {
      field: "assignedTo",
      headerName: "Assigned To",
      render: (_, row) => (
        <span onClick={() => openItem(row)} style={{ cursor: "pointer" }}>
          {row?.assignedTo?.name || "-"}
        </span>
      ),
    },
    {
      field: "dueDate",
      headerName: "Due Date",
      render: (val, row) => {
        if (!row.dueDate) {
          return (
            <span onClick={() => openItem(row)} style={{ cursor: "pointer" }}>
              -
            </span>
          );
        }

        const date = new Date(row.dueDate);

        return (
          <span onClick={() => openItem(row)} style={{ cursor: "pointer" }}>
            {date.toLocaleDateString("en-IN")}
          </span>
        );
      },
    },
    {
      field: "latestStatus",
      headerName: "Status",
      render: (_, row) => {
        const status = row.latestStatus || "Raised";

        let color = "#999";
        if (status === "Raised") color = "#d32f2f";
        if (status === "InProgress") color = "#f9a825";
        if (status === "Completed") color = "#2e7d32";

        return canEdit ? (
          <Button
            variant="contained"
            style={{
              backgroundColor: color,
              color: "white",
              textTransform: "none",
              minWidth: "120px",
            }}
            onClick={() => handleStatusClick(row)}
          >
            {status}
          </Button>
        ) : (
          <Button
            variant="contained"
            style={{
              backgroundColor: color,
              color: "white",
              textTransform: "none",
              minWidth: "120px",
              pointerEvents: "none",
            }}
          >
            {status}
          </Button>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      render: (val, row) =>
        canEditTicket ? (
          <CiEdit
            style={{ cursor: "pointer", fontSize: "24px" }}
            onClick={() => openEdit(row)}
          />
        ) : (
          <CiEdit style={{ cursor: "pointer", fontSize: "24px" }} />
        ),
    },
  ];

  const openCreate = () => {
    setEditMode(false);
    setTicket({
      title: "",
      type: "",
      description: "",
      severity: "",
    });
    setFile(null);
    setOpen(true);
  };

  const openEdit = (data) => {
    setEditMode(true);
    setTicket(data);
    setFile(data.file || null);
    setOpen(true);
  };

  const handleChange = (e) => {
    setTicket({
      ...ticket,
      [e.target.name]: e.target.value,
    });
  };
  const handleSubmit = () => {
    if (!ticket.title.trim()) {
      toast.error("Title is required");
      return;
    }

    if (!ticket.type.trim()) {
      toast.error("Type is required");
      return;
    }

    if (!ticket.description.trim()) {
      toast.error("Description is required");
      return;
    }
    if (!ticket.severity.trim()) {
      toast.error("Severity is required");
      return;
    }

    // if (!file && !editMode) {
    //   toast.error("Please upload a file");
    //   return;
    // }
    const payload = {
      title: ticket.title,
      type: ticket.type,
      description: ticket.description,
      severity: ticket.severity,
      file: file || "",
    };

    // UPDATE
    if (editMode) {
      dispatch(
        saveTicketRequest({
          ...payload,
          id: ticket._id,
        }),
      );
    }

    // CREATE
    else {
      dispatch(saveTicketRequest(payload));
    }

    setOpen(false);
    setTicket({
      title: "",
      type: "",
      description: "",
      severity: "",
    });
    setFile(null);
  };

  const handleStatusClick = (row) => {
    setSelectedTicketId(row._id);
    setSelectedStatus(row.latestStatus || "Raised");
    setStatusDialogOpen(true);
  };
  const openItem = (row) => {
    setSelectedTicket(row);
    setDrawerOpen(true);
  };

  const triggerCsvDownload = (csvText, filename) => {
    const blob = new Blob([csvText], { type: "text/csv" });

    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");

    a.href = url;

    a.download = filename;

    a.click();

    window.URL.revokeObjectURL(url);
  };

  const handleDownloadTicketsCsv = () => {
    dispatch(
      apiRequest({
        method: "GET",
        endpoint: "/api/v1/tickets/ticketsCsv",
        query: {},
        callback: (response) => {
          const csv = convertToCsv(response?.data || []);

          triggerCsvDownload(csv, "tickets.csv");
        },
      }),
    );
  };
  if (configData?.featureToggle?.Ticket_Management !== true) {
    return <FeatureUnavailable heading="Ticket Management" />;
  }

  return (
    <Box sx={{ width: "100%", height: "100%", overflow: "auto" }}>
        <Box sx={{ position: "relative" }}>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          marginTop: "70px",
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography fontWeight={700} fontSize={24} p={2}>
            Support Tickets
          </Typography>

          {canCreateTicket && (
            <Button variant="contained" sx={{ mr: 2 }} onClick={openCreate}>
              Create Ticket
            </Button>
          )}
        </Box>

        <CardContent>
          <Box mb={2} display="flex" gap={1}>
            <Button
              variant={statusFilter === "" ? "contained" : "outlined"}
              onClick={() => setStatusFilter("")}
            >
              All
            </Button>

            <Button
              variant={statusFilter === "Raised" ? "contained" : "outlined"}
              onClick={() => setStatusFilter("Raised")}
            >
              Raised
            </Button>

            <Button
              variant={statusFilter === "InProgress" ? "contained" : "outlined"}
              onClick={() => setStatusFilter("InProgress")}
            >
              In Progress
            </Button>

            <Button
              variant={statusFilter === "Completed" ? "contained" : "outlined"}
              onClick={() => setStatusFilter("Completed")}
            >
              Completed
            </Button>
          </Box>
          <Box
            mb={2}
            display="flex"
            alignItems="center"
            gap={2}
            flexWrap="wrap"
          >
            <Typography fontWeight={600}>Due Date</Typography>

            <TextField
              type="date"
              size="small"
              value={dueDateFilter}
              onChange={(e) => {
                setDueDateFilter(e.target.value);

                setPagination((prev) => ({
                  ...prev,
                  page: 0,
                }));
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />

            {dueDateFilter && (
              <Button
                variant="outlined"
                color="error"
                onClick={() => setDueDateFilter("")}
              >
                Clear
              </Button>
            )}
          </Box>
          <TableCompo
            columns={columns}
            data={ticketData || []}
            totalCount={total}
            onTableChange={handleTableChange}
            page={pagination.page}
            limit={pagination.limit}
            onRowClick={(row) => openItem(row)}
            extraButtons={
              <Button
                size="sm"
                variant="outlined"
                onClick={handleDownloadTicketsCsv}
              >
                Download CSV
              </Button>
            }
          />
        </CardContent>
      </Box>

      {/* Create / Edit Dialog */}

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
        <DialogTitle>{editMode ? "Edit Ticket" : "Create Ticket"}</DialogTitle>

        <DialogContent>
          <TextField
            label="Title"
            name="title"
            fullWidth
            margin="normal"
            value={ticket.title}
            onChange={(e) => {
              const value = e.target.value;
              if (/^[a-zA-Z\s]*$/.test(value)) {
                handleChange(e);
              }
            }}
          />

          <TextField
            select
            label="Type"
            name="type"
            fullWidth
            margin="normal"
            value={ticket.type}
            onChange={handleChange}
          >
            <MenuItem value="New_Feature">New Feature</MenuItem>
            <MenuItem value="Admin_Problem">Admin Problem</MenuItem>
            <MenuItem value="Customer_Problem">Customer Problem</MenuItem>
            <MenuItem value="Change_Request">Change Request</MenuItem>
          </TextField>

          <TextField
            label="Description"
            name="description"
            multiline
            rows={3}
            fullWidth
            margin="normal"
            value={ticket.description}
            onChange={handleChange}
          />

          <TextField
            select
            label="Severity"
            name="severity"
            fullWidth
            margin="normal"
            value={ticket.severity}
            onChange={handleChange}
          >
            <MenuItem value="Low">Low</MenuItem>
            <MenuItem value="Medium">Medium</MenuItem>
            <MenuItem value="Critical">Critical</MenuItem>
          </TextField>

          {editMode && ticket.file && (
            <Box mt={2}>
              <Typography variant="body2" mb={1}>
                Current File
              </Typography>

              <img
                src={ticket.file}
                alt="ticket"
                style={{
                  width: "120px",
                  borderRadius: "6px",
                  marginBottom: "10px",
                }}
              />
            </Box>
          )}
          <Box mt={2}>
            <Button variant="outlined" component="label">
              Upload File
              <input
                hidden
                type="file"
                onChange={(e) => setFile(e.target.files[0])}
              />
            </Button>

            {file && (
              <Typography variant="body2" ml={2}>
                {file.name}
              </Typography>
            )}
          </Box>

          <Button
            variant="contained"
            fullWidth
            sx={{ mt: 3 }}
            onClick={handleSubmit}
          >
            {editMode ? "Update Ticket" : "Create Ticket"}
          </Button>
        </DialogContent>
      </Dialog>
      <Dialog
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
        maxWidth="md"
      >
        <DialogTitle>Attachment</DialogTitle>
        <DialogContent>
          <Box display="flex" justifyContent="center">
            <img
              src={previewImage}
              alt="ticket"
              style={{
                maxWidth: "100%",
                maxHeight: "500px",
                borderRadius: "8px",
              }}
            />
          </Box>
        </DialogContent>
      </Dialog>
      <Dialog
        open={statusDialogOpen}
        onClose={() => setStatusDialogOpen(false)}
      >
        <DialogTitle>Change Status</DialogTitle>

        <DialogContent>
          <Box display="flex" gap={2} mb={3} mt={1}>
            <Button
              variant="contained"
              onClick={() => setSelectedStatus("Raised")}
              style={{
                backgroundColor: "#d32f2f",
                opacity: selectedStatus === "Raised" ? 1 : 0.5,
              }}
            >
              Raised
            </Button>

            <Button
              variant="contained"
              onClick={() => setSelectedStatus("InProgress")}
              style={{
                backgroundColor: "#f9a825",
                opacity: selectedStatus === "InProgress" ? 1 : 0.5,
              }}
            >
              In Progress
            </Button>

            <Button
              variant="contained"
              onClick={() => setSelectedStatus("Completed")}
              style={{
                backgroundColor: "#2e7d32",
                opacity: selectedStatus === "Completed" ? 1 : 0.5,
              }}
            >
              Completed
            </Button>
          </Box>

          <Box display="flex" justifyContent="flex-end" gap={2}>
            <Button
              variant="outlined"
              onClick={() => setStatusDialogOpen(false)}
            >
              Close
            </Button>

            <Button
              variant="contained"
              onClick={() => {
                dispatch(
                  updateTicketStatusRequest({
                    id: selectedTicketId,
                    status: selectedStatus,
                  }),
                );

                setStatusDialogOpen(false);
              }}
            >
              Save
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      <TicketItemDrawer
        open={drawerOpen}
        onClose={() => {
          setDrawerOpen(false);
          setSelectedTicket(null);
        }}
        ticket={selectedTicket}
      />
    </Box>
    <Box
    sx={{
      position: "fixed",
      bottom: 24,
      right: 24,
      zIndex: 1000,
    }}
  >
    <InfoButton pageName="TICKET_MANAGEMENT" />
  </Box>
    </Box>
  );
};

export default Tickets;
